// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Vqr9D","active":"CoBpG"};